import React, {PropTypes} from 'react';
import classNames from 'classnames';

const Drawer = ({opened, rtl, title, children, toggle, close}) => (
    <div className={classNames('cielo24-vwrap-drawer', {'cielo24-vwrap-opened': opened})}>
        <button type='button' className='cielo24-vwrap-toggle' onClick={toggle} aria-label={title}>
            <span className='cielo24-vwrap-title'>{title}</span>
            <i aria-hidden={true} className='cielo24-vwrap-icon cielo24-vwrap-icon-menu' />
        </button>
        <div className='cielo24-vwrap-container'>
            <button type='button' className='cielo24-vwrap-header' onClick={close} tabIndex={opened ? 0 : -1}>
                <span className='cielo24-vwrap-display'>{title}</span>
                <i
                    aria-hidden={true}
                    className={`cielo24-vwrap-icon cielo24-vwrap-icon-chevron-${rtl ? 'left' : 'right'}-thin`}
                />
            </button>
            <div className='cielo24-vwrap-content'>{children}</div>
        </div>
        <div className='cielo24-vwrap-overlay' onClick={close} />
    </div>
);

Drawer.propTypes = {
    opened: PropTypes.bool.isRequired,
    rtl: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default Drawer;



// WEBPACK FOOTER //
// ./scripts/components/entity-menu/drawer.js